import React, { FC, useEffect, useState } from "react";
import AuthContext, { Claim, ClientConfiguration } from "./AuthContext";
import userApi from "src/admin/Users/userAPI";
import { routeBlackList } from "src/@types/RouteBlacklist";

const AuthStore: FC = ({ children }) => {
	const [claims, setClaims] = useState<Claim[]>();
	const [currentUser, setCurrentUser] = useState<CurrentUserDTO>();
	const [claimsLoading, setClaimsLoading] = useState(true);
	const [currentUserLoading, setCurrentUserLoading] = useState(true);
	const [clientConfiguration, setClientConfiguration] =
		useState<ClientConfiguration>();

	useEffect(() => {
		getUserDetails();
		getUserClaims();
	}, []);

	useEffect(() => {
		if (claims) {
			getConfiguration();
		}
	}, [claims]);

	const getConfiguration = async () => {
		try {
			const resp = await fetch("/client-configuration", {
				headers: new Headers({
					"X-CSRF": "1",
					"content-type": "application/json",
				}),
			});
			if (resp.ok) {
				const config: ClientConfiguration = await resp.json();
				setClientConfiguration(config);
			}
		} catch (e) {
			console.error("unable to retrieve client configuration", e);
		}
	};

	const getUserDetails = async () => {
		try {
			const user = await userApi.getCurrentUser();
			setCurrentUser(user);
		} catch (e) {
			console.error("error getting current user details");

			//in a scenario where the asp.net core cookies are expired, redirect to login
			//prevent a loop by checking if we are already on the home page
			if (
				window.location.pathname.toLowerCase() !== "/" &&
				!routeBlackList.some((b) => window.location.pathname.toLowerCase().startsWith(b.toLowerCase()))
			) {
				window.location.href = "/";
			}
		} finally {
			setCurrentUserLoading(false);
		}
	};

	const getUserClaims = async () => {
		try {
			const resp = await fetch("/bff/user", {
				headers: new Headers({
					"X-CSRF": "1",
				}),
			});
			if (resp.ok) {
				const c: Claim[] = await resp.json();
				setClaims(c);
			}
		} catch (e) {
			console.error("error checking user status");
		} finally {
			setClaimsLoading(false);
		}
	};

	const initialState = {
		loading: claimsLoading || currentUserLoading,
		claims,
		currentUser,
		clientConfiguration,
		loggedIn:
			!!currentUser && !!claims && !claimsLoading && !currentUserLoading,
	};

	return (
		<AuthContext.Provider value={initialState}>{children}</AuthContext.Provider>
	);
};
export default AuthStore;
